import { UnprocessedOrderType } from '@business/pages/OrderManage/shared/types';
import { TagItem } from '../connection/eventHandler/order/api';

// eslint-disable-next-line import/no-mutable-exports
let menuTagList: any[] = [];

// 递归获取子孙subMenus的所有tag，从指定的起始层级开始收集，并在startLevel为1时返回父级tag
function getAllSubMenuTags(
    menu: TagItem<UnprocessedOrderType>,
    currentLevel: number,
    startLevel: number,
): string[] {
    let tags: string[] = [];

    // 当前层级 >= startLevel 时开始收集tag
    if (currentLevel >= startLevel) {
        // 只有在当前层级 > 1 时，才添加 tag，因为在 startLevel === 1 时已经手动添加过
        if (currentLevel > 1 && menu.tag) {
            tags.push(menu.tag);
        }
        if (menu.subMenus && Array.isArray(menu.subMenus)) {
            menu.subMenus.forEach(subMenu => {
                // 递归调用，进入下一层级
                tags = tags.concat(getAllSubMenuTags(subMenu, currentLevel + 1, startLevel));
            });
        }
    } else if (menu.subMenus && Array.isArray(menu.subMenus)) {
        // 层级未达到 startLevel 时，只递归，不收集 tag
        menu.subMenus.forEach(subMenu => {
            tags = tags.concat(getAllSubMenuTags(subMenu, currentLevel + 1, startLevel));
        });
    }

    return tags;
}

// 查找特定的 tag 并获取其子孙 subMenus 的 tag，从指定层级开始
function getTagsByParentTag(
    menuData: TagItem<UnprocessedOrderType>[],
    parentTag: string,
    startLevel: number,
): string[] {
    // eslint-disable-next-line no-restricted-syntax
    for (const menu of menuData) {
        if (menu.tag === parentTag) {
            const tags: string[] = [];
            // 如果 startLevel 为 1，先将 parentTag 加入 tags
            if (startLevel === 1) {
                tags.push(menu.tag);
            }
            // 获取子孙 subMenus 的 tags
            return tags.concat(getAllSubMenuTags(menu, 1, startLevel));
        }
    }
    return [];
}
function setMenuTagList(menuTempInfo: any[]) {
    menuTagList = menuTempInfo;
}

export { getTagsByParentTag, setMenuTagList, menuTagList };
